<mat-card class="example-card">
  <mat-card-header>
    <mat-card-title>Utilisateurs</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div>
      <p> <strong> ID:</strong> {{user.id}}</p>
    </div>
    <div>
      <p> <strong>Email:</strong> {{user.email}}</p>
      <button mat-raised-button color="accent" (click)="updateEmailPopUp(user.email)">Update email</button>
    </div>
    <div>
      <button mat-raised-button color="accent" (click)="resetPassword(user.email)">Reset password</button>
    </div>
    <div>
      <p> <strong>Nom:</strong> {{user.displayName}}</p>
    </div>


    <div>
      <p>   <strong>Role:</strong> {{user.role}}</p>
    </div>
    <div *ngIf="user.createdAt">
      <p> <strong>Date de création:</strong> {{user.createdAt.seconds*1000 | date: 'dd MMMM yyyy' }}</p>
    </div>
    <button mat-raised-button color="accent" *ngIf="user.role != 'subuser'" (click)="addGroup(user)"> ADD Group </button>
    <div>
      <div *ngIf="licences">
        <h3>Licences</h3>
        <div *ngFor="let licence of licences">
          <p><strong>Type:</strong> {{licence.type}}</p>
          <p><strong>Debut:</strong> {{licence.startDate.toDate() | date: 'medium'}}</p>
          <p><strong>Fin:</strong> {{licence.endDate.toDate() | date: 'medium'}}</p>
          <div>
            <p><strong>Liste device:</strong></p>
            <div *ngFor="let device of licence.listDevice; let i = index" class="device"><p class="idDevice">{{device}}</p> <button (click)="removeIdDevice(i, licence.type)"><mat-icon>delete</mat-icon></button> </div>
          </div>

          <mat-form-field class="example-form-field" appearance="fill">
            <mat-label>Nombre de licence</mat-label>
            <input matInput type="number" [(ngModel)]="licence.nbr" (change)="updateUserValue('licence', licences)">
          </mat-form-field>
        </div>
      </div>

      <div *ngFor="let group of groups">

        <div *ngIf="group.parent == user.id">
          <div>
            <div class="groupActionsLocal">
              <h3>   {{group.name}}</h3>
              <button mat-raised-button color="warn" (click)="deleteGroup(group.name, user.id)"> REMOVE Group </button>
            </div>
            <button mat-raised-button color="accent" (click)="addDevice(user, group.name, group.id)"> ADD DEVICE </button>
          </div>

          <div *ngFor="let device of devices; let i = index">
            <div class="deviceContainer" *ngIf="device.data != undefined && device.data.parent == user.uid && device.data.group == group.name">
              <div class="deviceName">
                <h3>  {{device.data.name}}</h3>
              </div>
              <div class="moduleContainer">
                <div *ngFor="let module of modulesArray">
                  <div *ngIf="device.data.modules != undefined">
                    <label for="module.name">{{module.name}}</label>
                    <input label="module.name" [name]="module.name" type="checkbox" [(checked)]="device.data.modules[module.name]" (change)="deviceModules(module, $event ,device, user)" />
                  </div>
                  <div *ngIf="device.data.modules  == undefined">
                    <label for="module.name">{{module.name}}</label>
                    <input label="module.name" [name]="module.name" type="checkbox" (change)="deviceModules(module, $event ,device, user)" />
                  </div>

                </div>

              </div>
              <div>
                <h3>Cacher borne</h3>
                <mat-slide-toggle color="accent" type="checkbox" name="enable" (change)="updateDeviceHideState(device, user)" [(ngModel)]="device.data.hideDevice"></mat-slide-toggle>
              </div>
              <div class="deviceActions">
                <button mat-raised-button color="warn" (click)="deleteDevice(device)">REMOVE DEVICE</button>
              </div>
            </div>
          </div>

          <div>

          </div>
        </div>

      </div>

    </div>
  </mat-card-content>
  <mat-card-actions>
    <button mat-raised-button color="warn" mat-button *ngIf="user.role != 'admin'" (click)="deleteUser(user.id)">DELETE USER</button>
  </mat-card-actions>
</mat-card>
